import { render, staticRenderFns } from "./CreateLecturerModal.vue?vue&type=template&id=c63f6c3c&scoped=true&"
import script from "./CreateLecturerModal.vue?vue&type=script&lang=js&"
export * from "./CreateLecturerModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateLecturerModal.vue?vue&type=style&index=0&id=c63f6c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f6c3c",
  null
  
)

export default component.exports